// 导入 types.js 文件
import types from "./../types";
import Vue from "vue"
import {
  instance,
  login,
  getUserInfo,
  expireSoonMission,
  expiringMission,
  expiringSubTask,
  getAdminMessage,
  showsubTask,
  getUserMessage,
  createAdminMessage,
  backMessage,
  getMissionByPk,
  back
} from '../../api/index.js';
import {
  giveRouter
} from "../../utils/index";
import {
  stat
} from "fs";
import {
  strict
} from "assert";
const state = {
  token: window.sessionStorage.getItem('token'),
  loginStatus: false,
  userInfo: null,
  message: [], //新增一个message属性
  userRouter: [],
  testMessage: []

}

// 定义 getters
var getters = {

}

const mutations = {
  [types.LOGINSTATUS](state, status) {
    state.loginStatus = status;
  },
  [types.TOKEN](state, token) {
    state.token = token;
  },
  [types.USERINFO](state, userInfo) {
    state.userInfo = userInfo;
  },
  [types.USERROUTER]: (state, value) => {
    state.userRouter = value;
  },
  [types.CLEARMESSAGE]: (state, value) => {
    state.message = value
  },
  // [types.MESSAGE]: (state, o) => {                      //获取过期/即将过期消息
  //   // console.log(value)
  //   var value = o.data
  //   // console.log(value)
  //   if (state.message.length == 0) {                  //如果消息长度为空，直接推进去
  //     for (var i = 0; i < value.length; i++) {
  //       if (o.type == "expireSoon") {
  //         Vue.set(value[i], "tag", "[核查处置][即将过期]")      //设置即将到期消息的tag标签     
  //         Vue.set(value[i], "isRead", 0)   

  //       }
  //       if (o.type == "expiring") {
  //         Vue.set(value[i], "tag", "[核查处置][任务过期]")
  //         Vue.set(value[i], "isRead", 0)   
  //       }
  //       if(o.type=="expiringSubTask"){
  //         Vue.set(value[i],"tag","[通用任务][任务过期]")
  //         Vue.set(value[i], "isRead", 0)   
  //       }
  //       state.message.push(value[i])
  //       // console.log("message",state.message)
  //     }
  //   }
  //   else {
  //     for (let i = 0; i < state.message.length; i++) {                //如果消息长度，不为空，则去掉重复的，再推进去
  //       for (let j = 0; j < value.length; j++) {
  //         if (state.message[i].missionId == value[j].missionId) {
  //           value.splice(j, 1)
  //         };
  //       }
  //     }
  //     for (let k = 0; k < value.length; k++) {
  //       if (o.type == "expireSoon") {
  //         Vue.set(value[k], "tag", "[核查处置][即将过期]")
  //         Vue.set(value[k], "isRead", 0)   
  //       }
  //       if (o.type == "expiring") {
  //         Vue.set(value[k], "tag", "[核查处置][任务过期]")
  //         Vue.set(value[k], "isRead", 0)   
  //       }
  //       if(o.type=="expiringSubTask"){
  //         Vue.set(value[k],"tag","[通用任务][任务过期]")
  //         Vue.set(value[k], "isRead", 0)   
  //       }
  //       state.message.push(value[k])

  //     }
  //   }
  //   // console.log("message",state.message)


  // },
  [types.ADMINMESSAGE]: (state, o) => {
    
      if (o.type == "returnSuccess") {
        o.tag = "[通用任务][回传提醒]"
      }
      if (o.type == "supplySuccess") {
        o.tag = "[通用任务][补传提醒]"
      }

      state.message.push(o)
      state.message = state.message.sort(function sortData(a, b) {
        return (new Date(b.createDate).getTime() - new Date(a.createDate).getTime())
      })
    // } else {
    //   for (let i = 0; i < state.message.length; i++) {
    //     if (state.message[i].subTaskId == o.subTaskId && state.message[i].nickname == o.nickname) {
    //       return
    //     }
    //   }
    //   if (o.type == "returnSuccess") {
    //     o.tag = "[通用任务][回传提醒]"
    //   }
    //   if (o.type == "supplySuccess") {
    //     o.tag = "[通用任务][补传提醒]"
    //   }
    //   state.message.push(o)
    //   state.message = state.message.sort(function sortData(a, b) {
    //     return (new Date(b.createDate).getTime() - new Date(a.createDate).getTime())
    //   })
    

  },
  [types.USERMESSAGE]: (state, o) => {
    // console.log(state.userInfo.nickname)
    // console.log(o)
    if (state.message.length == 0) {
      if (o.type == 0) {
        o.tag = "[核查处置][即将过期]"
      }
      if (o.type == 1) {
        o.tag = "[核查处置][任务退回]"
      }
      if (o.type == 2) {
        o.tag = "[通用任务][有新任务]"
      }
      if (o.type == 3) {
        o.tag = "[通用任务][结束任务]"
      }
      if (o.type == 4) {
        o.tag = "[核查处置][任务过期]"
      }
      if (o.type == 5) {
        o.tag = "[通用任务][任务过期]"
      }
      if (o.type == 6) {
        o.tag = "[通用任务][任务删除]"
      }
      if (o.type == 7) {
        o.tag = "[通用任务][新子任务]"
      }
      if (o.acceptName == state.userInfo.nickname) {

        state.message.push(o)
      }

      // console.log("state",state.message)
    } else {
      for (let i = 0; i < state.message.length; i++) {
        if (state.message[i].acceptName == o.acceptName && state.message[i].taskName == o.taskName && o.type == state.message[i].type) {
          return
        }
      }
      if (o.type == 0) {
        o.tag = "[核查处置][即将过期]"
      }
      if (o.type == 1) {
        o.tag = "[核查处置][任务退回]"
      }
      if (o.type == 2) {
        o.tag = "[通用任务][有新任务]"
      }
      if (o.type == 3) {
        o.tag = "[通用任务][结束任务]"
      }
      if (o.type == 4) {
        o.tag = "[核查处置][任务过期]"
      }
      if (o.type == 5) {
        o.tag = "[通用任务][任务过期]"
      }
      if (o.type == 6) {
        o.tag = "[通用任务][任务删除]"
      }
      if (o.type == 7) {
        o.tag = "[通用任务][新子任务]"
      }
      if (o.acceptName == state.userInfo.nickname) {
        // console.log(o.acceptName)
        state.message.push(o)
      }
    }
    // console.log(state.message)
  },
  [types.READMESSAGE]: (state, o) => {
    for (let i = 0; i < state.message.length; i++) {
      if (state.message[i].id == o.id && state.message[i].tag == o.tag) {
        state.message[i].isRead = 1;
      }

    }
  },
  [types.MESSAGE]: (state) => {
    if (state.userInfo.isAdmin) {
      getAdminMessage().then((res) => {
        const data = res.data.data
        // console.log("data",data)
        for (let i = 0; i < data.length; i++) {
          if (data[i].nickname == "Administartor" && (data[i].type == 3 || data[i].type == 0)) {
            getMissionByPk(data[i].TaskId).then((res) => {
              if (data[i].type == 0) {
                Vue.set(res.data.mission, "tag", "[核查处置][即将过期]")
                Vue.set(res.data.mission, "TaskId", data[i].TaskId)
                Vue.set(res.data.mission, "nickname", data[i].nickname)
                Vue.set(res.data.mission, "isRead", data[i].isRead)
                Vue.set(res.data.mission, "createDate", data[i].createDate)
              }
              if (data[i].type == 3) {
                Vue.set(res.data.mission, "tag", "[核查处置][任务过期]")
                Vue.set(res.data.mission, "TaskId", data[i].TaskId)
                Vue.set(res.data.mission, "nickname", data[i].nickname)
                Vue.set(res.data.mission, "isRead", data[i].isRead)
                Vue.set(res.data.mission, "createDate", data[i].createDate)
              }

              if (state.message.length == 0) {
                state.message.push(res.data.mission)
              } else {
                for (let j = 0; j < state.message.length; j++) {
                  if (state.message[j].missionId == res.data.mission.missionId) {
                    return
                  }
                }
                state.message.push(res.data.mission)
              }

            }).catch((err) => {
              console.log(err)
            })
          }
          if (data[i].nickname == "Administartor" && (data[i].type == 4)) {
            showsubTask(data[i].TaskId).then((res) => {
              // console.log("res",res)
              // res.data.subTaskData["tag"]="[通用任务][任务过期]"
              if (!res.data.subTaskData) {
                return
              }
              Vue.set(res.data.subTaskData, "tag", "[通用任务][任务过期]")
              Vue.set(res.data.subTaskData, "TaskId", data[i].TaskId) //common Id
              Vue.set(res.data.subTaskData, "nickname", data[i].nickname) //设置用户名
              Vue.set(res.data.subTaskData, "isRead", data[i].isRead) //设置是否已读
              Vue.set(res.data.subTaskData, "createDate", data[i].createDate)

              if (state.message.length == 0) {
                state.message.push(res.data.subTaskData)
              } else {
                for (let j = 0; j < state.message.length; j++) {
                  if (state.message[j].subTaskId == res.data.subTaskData.subTaskId && state.message[j].nickname == res.data.subTaskData.nickname) {
                    return
                  }


                }
                state.message.push(res.data.subTaskData)
                state.message = state.message.sort(function sortData(a, b) {
                  return (new Date(b.createDate).getTime() - new Date(a.createDate).getTime())
                })
              }

            })
            
            

          }

        }

      })

    }

  },
  [types.TEST]: (state) => {

  }
}

const actions = {
  doLogin({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      login(info).then(res => {
        if (res.status === 200) {
          if (res.data.code) {
            commit(types.TOKEN, res.data.token);
            commit(types.LOGINSTATUS, true);
            //获取登陆token保存到sessionStorage
            window.sessionStorage.setItem('token', res.data.token);
            //设置axios跨域请求和token
            // instance.defaults.headers = {
            //         'Content-Type': 'application/x-www-form-urlencoded',
            //         'Authorization': window.sessionStorage.getItem('token')
            //     }
            instance.defaults.headers.common['Authorization'] = res.data.token;
            instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
            //instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
          }
        }
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  logOut({
    commit
  }) {
    return new Promise((resolve, reject) => {
      commit(types.USERINFO, null)
      commit(types.LOGINSTATUS, false)
      commit(types.TOKEN, '')
      commit(types.USERROUTER, [])
      commit(types.CLEARMESSAGE, [])
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('store')
      resolve()
    })
  },
  getUserInfo({
    commit
  }, username) { //获取用户信息
    return new Promise((resolve, reject) => {
      getUserInfo(username).then(res => {
        if (res.status === 200) {
          commit('USERINFO', res.data.userInfo);
          window.sessionStorage.setItem('isAdmin', res.data.userInfo.isAdmin);
          //根据用户角色动态分配路由
          // 注册用户路由到vuex
          let userRouter = giveRouter(res.data.userInfo.isAdmin);
          commit('USERROUTER', userRouter);
        }
        resolve(res)
      }).catch((error) => {
        reject(error);
      })
    })
  },
  expireSoonMission({
    commit
  }) {
    return new Promise((resolve, reject) => {
      expireSoonMission().then(res => {
        if (res.status === 200) {
          var o = {} //用一个对象的方式存储
          o.type = "expireSoon" //传递的是即将过期的消息
          o.data = res.data.data
          // console.log("res",res.data.data)

          for (let i = 0; i < o.data.length; i++) {
            const message = {}
            var message = {}
            message.TaskId = o.data[i].missionId //管理端消息Id
            message.type = 0 //管理端消息类型
            message.nickname = "Administartor"
            createAdminMessage(message).then((res) => { //创建管理端信息
              // console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            message.missionId = o.data[i].missionId //生成用户端信息
            backMessage(message).then((res) => {
              // console.log(res)
            }).catch((err) => {
              console.log(err)
            })

          }

        }
        // commit("TEST")
        commit("MESSAGE")
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  expiringMission({
    commit
  }) {
    return new Promise((resolve, reject) => {
      expiringMission().then(res => {
        if (res.status === 200) {
          var o = {}
          o.type = "expiring"
          o.data = res.data.data
          for (let i = 0; i < o.data.length; i++) {
            const message = {}
            var message = {}
            message.TaskId = o.data[i].missionId //生成管理端消息提醒
            message.type = 3
            message.nickname = "Administartor"
            createAdminMessage(message).then((res) => {
              // console.log(res)
            }).catch((err) => {
              console.log(err)
            })
            message.missionId = o.data[i].missionId //生成用户端信息
            message.type = 4
            backMessage(message).then((res) => {
              // console.log(res)
            }).catch((err) => {
              console.log(err)
            })


          }

        }
        // commit("TEST")
        commit("MESSAGE")

        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // expiringSubTask({commit}){
  //   return new Promise((resolve,reject)=>{
  //     expiringSubTask().then(res=>{
  //       var o={}
  //       o.type="expiringSubTask"
  //       o.data=res.data.data
  //       // console.log("res2",res.data.data)
  //       for (let i = 0; i < o.data.length; i++) {
  //         const message={}
  //         var message={}
  //         message.TaskId=o.data[i].subTaskId
  //         message.type=4
  //         message.nickname="Administartor"

  //         createAdminMessage(message).then((res)=>{
  //           // console.log(res)
  //         }).catch((err)=>{
  //           console.log(err)
  //         })
  //         message.taskId=o.data[i].subTaskId
  //         message.type=5
  //         backMessage(message).then((res)=>{
  //           // console.log(res)
  //         }).catch((err)=>{
  //           console.log(err)
  //         })


  //       }
  //       commit("MESSAGE")
  //       resolve(res)
  //     }).catch((error)=>{
  //       reject(error)
  //     })
  //   })
  // },
  getAdminMessage({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getAdminMessage().then(res => {
        var arr = res.data.data
        // console.log(arr)
        // console.log(arr)
        for (let i = 0; i < arr.length; i++) {
          // console.log(arr[i].nickname)
          var result = new Promise((resolve, reject) => {
            showsubTask(arr[i].TaskId).then(res => {
              // console.log("arr[i]",arr[i])
              if (arr[i].type == 0) {
                return
              }
              var o = res.data.subTaskData
              if (arr[i].type == 1) {
                o.type = "returnSuccess" //回传成功标签
                o.isRead = arr[i].isRead;
                o.department = arr[i].department
                o.createDate = arr[i].createDate
              }
              if (arr[i].type == 2) {
                o.isRead = arr[i].isRead;;
                o.type = "supplySuccess" //补传成功标签
                o.department = arr[i].department
                o.createDate = arr[i].createDate
              }
              if (arr[i].type == 3 || arr[i].type == 4) {
                return
              }
              o.nickname = arr[i].nickname
              o.department = arr[i].department
              commit("ADMINMESSAGE", o)
              resolve(res.data)
            }).catch((error) => {
              reject(error)
            })
          })


        }
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getUserMessage({
    commit
  }, {
    state
  }) {
    return new Promise((resolve, reject) => {
      getUserMessage().then(res => {
        var arr = res.data.data
        console.log("arr=>", arr)

        for (let i = 0; i < arr.length; i++) {

          commit("USERMESSAGE", arr[i])
        }
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  changeRead({
    commit
  }, o) {

    commit("READMESSAGE", o)
  },

  clear({
    commit
  }) {
    return new Promise((resolve, reject) => {
      commit(types.CLEARMESSAGE, [])
      resolve()
    })
  }

}

// 最后统一导出
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js